import React, { useMemo, useState } from 'react';

import { Navigate } from 'react-router';

import { Layout } from '../../components/Layout';
import { SiteMetadata } from '../../components/SiteMetadata';
import { useFirebaseAuth, useStoreData } from '../../hooks';
import { ErrorPage } from '../ErrorPage';
import { Sections } from './components/Sections';
import { PageContext } from './context';
import { usePageData } from './hooks/usePageData';

export const Page = () => {
    /**
     * The loader should initally show up because we didn't fetched
     * any data yet. When we got all needed data we have to set it to `false`
     */
    const [pageLoader, setPageLoader] = useState(true);

    const { currentUser } = useFirebaseAuth();

    const { error } = useStoreData().site;

    const { currentPageData, setCurrentPageData } = usePageData();

    const value = useMemo(
        () => ({
            currentPageData,
            setCurrentPageData,
            currentUser,
            setPageLoader,
        }),
        [currentPageData],
    ) as any;

    if (error) {
        return <ErrorPage error={error} />;
    }

    if (currentPageData === 'notFound') {
        return <Navigate to="/" />;
    }

    if (!currentPageData) {
        return null;
    }

    const {
        page_layout: pageLayout,
        site_title: siteTitle,
        site_description: siteDescription,
    } = currentPageData.content;

    return (
        <PageContext.Provider value={value}>
            <Layout variant={pageLayout}>
                <SiteMetadata title={siteTitle} description={siteDescription} />
                <Sections />
            </Layout>
        </PageContext.Provider>
    );
};

export * from './context';
